import { forwardRef, useCallback, useState } from "react"
import { Box, Typography, useTheme } from "@mui/material"
import MuiAlert from "@mui/material/Alert"
import SvgInfoCircle from "ideep-design-system-2/icons/InfoCircle"
import { CustomContentProps, SnackbarContent, useSnackbar } from "notistack"

import { consumeApiErrorMessage } from "~/services/core/api-error-snackbar"

const CustomErrorSnackbar = forwardRef<HTMLDivElement, CustomContentProps>(
  ({ id, action, ...props }, ref) => {
    const theme = useTheme()
    const htmlTag = document.documentElement
    const dirAttribute = htmlTag.getAttribute("dir")
    const currentDirection = dirAttribute === "rtl" ? "rtl" : "ltr"
    const { closeSnackbar } = useSnackbar()
    const [message] = useState(() => consumeApiErrorMessage(id, props.message))
    const handleCloseTraceId = useCallback(() => {
      closeSnackbar(id)
    }, [id, closeSnackbar])

    return (
      <SnackbarContent ref={ref}>
        <MuiAlert
          dir={currentDirection}
          severity='error'
          icon={
            <SvgInfoCircle
              width={16}
              height={16}
              primarycolor={theme.palette.text["16"]}
            />
          }
          sx={{
            width: "100%",
            minWidth: 350,
            alignItems: "center",
            ".MuiAlert-message": { py: 0 },
            backgroundColor: "error.3",
          }}
          onClose={handleCloseTraceId}
        >
          <Box
            display='flex'
            alignItems='center'
            justifyContent='space-between'
            gap={2}
          >
            <Typography color='text.16'>{message}</Typography>

            {typeof action === "function" ? action(id) : action}
          </Box>
        </MuiAlert>
      </SnackbarContent>
    )
  },
)

CustomErrorSnackbar.displayName = "CustomErrorSnackbar"
export default CustomErrorSnackbar
